/**
 * @description
 * @author librajt
 */

import Api from '../../path'
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    type: string;
}
type IOutput = string[];

export const clickAd = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.CLICK_ADD, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});
